import { FC } from 'react';
import { Form, Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import classes from './index.module.css';
import cn from "src/utils/cn";

interface TextAreaInputInterface extends TextAreaProps {
	name: string;
	label: string;
	rules?: any;
	placeholder?: string;
	maxLength?: number;
	showCount?: boolean;
}

const TextArea: FC<TextAreaInputInterface> = ({
	name,
	label,
	rules,
	placeholder,
	maxLength,
	showCount,
	...props
}): React.JSX.Element => (
	<Form.Item name={name} label={label} rules={rules} className={classes['text-area-box']}>
		<Input.TextArea
			placeholder={placeholder}
			showCount={showCount}
			maxLength={maxLength}
			className={cn(classes['text-area-input'], props?.className)}
			{...props}
		/>
	</Form.Item>
);

export default TextArea;
